import { type FC } from "react";

import { t } from "i18n/i18n";
import { Listbox } from "mds/components/Listbox";
import { FolderIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { courseGroupingSelectors } from "store/selectors/base";
import { ADMIN_COURSE_EVENT_PREFIX } from "utils/amplitude";

type CourseGroupingDropdownProps = {
  selectedGroupingId: string | null;
  onSelectionChange: (groupingId: string | null) => void;
};

export const CourseGroupingDropdown: FC<CourseGroupingDropdownProps> = ({
  selectedGroupingId,
  onSelectionChange,
}) => {
  const groupings = useAppSelector(courseGroupingSelectors.selectAll);

  const dropdownItems = [
    {
      id: "",
      title: t("home.courses.select_a_grouping"),
    },
    ...groupings.map((grouping) => ({
      id: grouping.id,
      title: grouping.title,
      iconStart: <FolderIcon />,
    })),
  ];

  return (
    <Listbox
      buttonText={!selectedGroupingId ? t("home.courses.select_a_grouping") : undefined}
      className="flex w-full items-center !justify-between"
      eventName={`${ADMIN_COURSE_EVENT_PREFIX}Add Course - Select Folder`}
      items={dropdownItems}
      selectedValue={selectedGroupingId || ""}
      onSelectionChange={(item) => {
        onSelectionChange(item.id === "" ? null : item.id);
      }}
    />
  );
};
